import { Link } from 'react-router-dom';
import { categories, navLinks, siteInfo } from '@/mocks/site';

function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              把分散的热点快讯、媒体报道与转载动态收进同一条时间线，帮你看清一件事的起因与走向。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/80 transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">热点分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/topics?category=${encodeURIComponent(cat.key)}`}
                    className="text-sm text-background-200/80 transition-colors hover:text-primary-300"
                  >
                    {cat.key}热点
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">联系与投稿</h4>
            <p className="mt-4 text-sm text-background-200/80">
              内容纠错、媒体合作与线索投稿：
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-2 inline-flex items-center gap-2 text-sm text-primary-300 hover:text-primary-200"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
            <p className="mt-4 text-xs text-background-300/70">{siteInfo.updateFreq}</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300/70">
            © {new Date().getFullYear()} {siteInfo.name} · 聚合视角看热点
          </p>
          <p className="text-xs text-background-300/70">
            站内内容为公开信息聚合整理，不代表对任何事件的立场判断。
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;